<template>
  <v-app-bar app
    id="core-toolbar"
    flat
    dense
    max-height="48px"
    style="background: #eee;"
  >
    <v-app-bar-nav-icon>
      <v-icon color="#999" @click.stop="onClickBtn">mdi-view-list</v-icon>
    </v-app-bar-nav-icon>
    <span class="text-uppercase font-weight-bold" style="color: #999">{{ title }}</span>
    <v-spacer />
    <v-toolbar-items>
      <v-flex
        align-center
        layout
        py-2
      >
        <v-text-field
          class="mr-4 purple-input"
          label="Search..."
          hide-details
          color="purple"
        />
        <router-link
          v-ripple
          class="toolbar-items"
          to="/"
        >
          <v-icon color="tertiary">mdi-view-dashboard</v-icon>
        </router-link>
        <v-menu
          bottom
          left
          content-class="dropdown-menu"
          offset-y
          transition="slide-y-transition">
          <template v-slot:activator="{ on }">
            <router-link
                v-ripple
                v-on="on"
                class="toolbar-items"
                to="/notifications"
            >
                <v-badge
                color="error"
                overlap
                >
                <template slot="badge">
                    {{ notifications.length }}
                </template>
                <v-icon color="tertiary">mdi-bell</v-icon>
                </v-badge>
            </router-link>
          </template>
          <v-card>
            <v-list dense>
              <v-list-tile
                v-for="notification in notifications"
                :key="notification"
                @click="onClick"
              >
                <v-list-tile-title
                  v-text="notification"
                />
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
        <router-link
          v-ripple
          class="toolbar-items"
          to="/user"
        >
          <v-icon color="tertiary">mdi-account</v-icon>
        </router-link>
      </v-flex>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>

import { mapMutations } from 'vuex'

export default {
  data: () => ({
    notifications: [],
    title: null,
    responsive: false
  }),

  watch: {
    '$route' (val) {
      this.title = val.meta.title
    }
  },

  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClickBtn () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onClick () {
      //
    },
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    }
  }
}
</script>

<style>
  #core-toolbar a {
    text-decoration: none;
  }
</style>
